module.exports = __webpack_public_path__ + "static/media/TRIAL-1-if-correct.26a5fe39.mp3";